import { configureStore } from '@reduxjs/toolkit';
import { applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';

let middlewares = [thunk]; // add your middleware here

if (process.env.REACT_APP_STAGE === 'dev') {
  middlewares.push(logger);
}

const store = configureStore({ reducer: rootReducer }, compose(applyMiddleware(...middlewares)));

export default store;
